export enum LocalStorageObjects {
	UserConfig = 'userConfig',
	InitialRoute = 'initialRoute',
}
